<template>
  <div>
    <!-- 显示用户信息 -->
    <div
      class="account-info"
      v-if="isShowInfo"
      :style="generateInnerStyles(config.logged_in)"
    >
      <div class="info" v-if="!!isOnline">
        <div v-if="userInfo && userInfo.role_id">
          <span
            class="main-title"
            :style="'color:' + config.logged_in.main_title_color"
            >{{ config.logged_in.game_name }}</span
          >
          <template v-if="userInfo.account">
            <span
              class="sub-title"
              :style="'color:' + config.logged_in.sub_title_color"
              >{{
                userInfo["role_name"] + "[" + userInfo["server_name"] + "]"
              }}</span
            >
          </template>
          <template v-else>
            <span
              class="sub-title"
              :style="'color:' + config.logged_in.sub_title_color"
              >{{ userInfo["role_name"] + "[" + userInfo["os"] + "]" }}</span
            >
          </template>
        </div>
        <div v-else>
          <span
            class="main-title"
            :style="'color:' + config.logged_in.main_title_color"
            v-if="isRecall"
            >{{ config.logged_in.game_name }}</span
          >
          <strong :style="'color:' + config.logged_in.tips_color || '#fff'">{{
            isRecall ? "一周年庆庆典现已开启" :config.logged_in.nologin_text?config.logged_in.nologin_text: "请先登录"
          }}</strong>
        </div>
      </div>
      <div
        v-else
        class="info"
        :style="
          isVip && isShake
            ? 'left: 1.87rem;width: 3.8rem'
            : isShake
            ? 'left: 3.5rem;width: 3.8rem'
            : ''
        "
      >
        <div v-if="Object.keys(userInfo).length > 0">
          <div>
            <span
              class="main-title"
              :style="'color:' + config.logged_in.main_title_color"
              >{{ config.logged_in.game_name }}</span
            >
            <template>
              <span
                class="sub-title"
                v-if="!isVip"
                :style="'color:' + config.logged_in.sub_title_color"
                >{{ userInfo.account }}</span
              >
              <span
                class="sub-title"
                v-if="isVip"
                :style="'color:' + config.logged_in.sub_title_color"
                >{{
                  userInfo["role_name"] + "[" + userInfo["server_name"] + "]"
                }}</span
              >
            </template>
          </div>
        </div>
        <div v-else>
          <span
            class="main-title"
            :style="'color:' + config.logged_in.main_title_color"
            v-if="isShake"
            >{{ config.logged_in.game_name }}</span
          >
          <strong :style="'color:' + config.logged_in.tips_color || '#fff'"
            >{{config.logged_in.nologin_text || '请先登录'}}</strong
          >
        </div>
      </div>
      <div
        class="btn official-btn ambush"
        data="0"
        title="官网"
        :style="config.operation_btn.office_website.style || ''"
      >
        <a
          v-if="isOnline == 0 && !isShake"
          href="javascript:;"
          @click="onActivePage()"
        >
          <img :src="config.operation_btn.join_active.img" alt="预约页" />
        </a>
        <a
          v-if="isOnline != 0 && !isShake"
          href="javascript:;"
          @click="onOfficial()"
        >
          <img :src="config.operation_btn.office_website.img" alt="官网" />
        </a>
      </div>
      <div
        :class="userInfo.account ? 'btn os-btn' : 'btn login-btn'"
        :style="loginOsStyle()"
      >
        <img
          v-if="userInfo.role_id && userInfo.account"
          alt="切换账户"
          :src="config.operation_btn.change_account.img"
          @click="changeAccount()"
        />
        <img
          v-else-if="
            isOnline
              ? userInfo.role_id && !userInfo.account
              : !isOnline && userInfo.account
          "
          alt="注销渠道账户"
          :src="config.operation_btn.logout.img"
          @click="onLogout()"
        />
        <img
          v-else
          alt="登陆"
          :src="config.operation_btn.login.img"
          @click="onLogin()"
        />
      </div>
    </div>
    <!-- 不显示用户信息 -->
    <div
      v-else
      class="account-info account-info-help"
      title="头部信息"
      :style="generateInnerStyles(config.not_logged_in)"
    >
      <div class="info"></div>
      <div
        class="btn official-btn ambush"
        data="0"
        title="官网"
        :style="config.operation_btn.office_website.style || ''"
      >
        <a href="javascript:;" @click="onOfficial()">
          <img :src="config.operation_btn.office_website.img" alt="官网" />
        </a>
      </div>
      <div
        class="btn tab-participation"
        title="参与活动"
        :style="config.operation_btn.join_active.style || ''"
      >
        <a href="javascript:;" @click="onActivePage()">
          <img :src="config.operation_btn.join_active.img" alt="参与活动" />
        </a>
      </div>
    </div>

    <!-- 渠道账户注销弹窗 -->
    <div class="popup_wrap logout-confirm-wrap" v-show="logoutPopup">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="popup-wrap-box" v-show="logoutPopup">
          <div class="content">
            <p>确认注销当前用户？</p>
          </div>
          <div class="operation">
            <div @click.stop="changeLogoutPopup(false)">取消</div>
            <div @click.stop="confirmLogout()">确认</div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="logoutPopup"
        @click.stop="changeLogoutPopup(false)"
      ></div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { transformStyle } from "@/utils/utils";
import { LogoutAPI } from "@/api/login";
export default {
  name: "help",
  created() {},
  updated() {
    // console.log("userInfo:",this.userInfo);
  },
  props: {
    isShowInfo: {
      type: Boolean,
      default: true,
    },
    activeLink: {
      type: String,
      default: "",
    },
    config: {
      type: Object,
      default: null,
    },
    isOnline: {
      type: Number,
      default: 0,
    },
    // 是否是小樱摇一摇活动
    isShake: {
      type: Boolean,
      default: false,
    },
    // 是否是小樱VIP活动
    isVip: {
      type: Boolean,
      default: false,
    },
    // 是否是小樱召回活动
    isRecall: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logoutPopup: false,
    };
  },
  filters: {
    filterName(str) {
      switch (str) {
        case 26:
          return "光子服";
        case 42:
          return "正式服";
        default:
          break;
      }
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    // 处理行内样式
    generateInnerStyles(cssAttr) {
      return transformStyle(cssAttr);
    },
    loginOsStyle() {
      let style = "";
      const config = this.config;
      const userInfo = this.userInfo;
      if (userInfo.role_id && userInfo.account) {
        style = config.operation_btn.change_account.style;
      } else if (userInfo.role_id && !userInfo.account) {
        style = config.operation_btn.logout.style;
      } else {
        style = config.operation_btn.login.style;
      }
      return style || "";
    },
    isCount() {},
    // 切换账号
    changeAccount() {
      this.changeOsPopup(true);
    },
    // 登陆
    onLogin() {
      this.changeLoginPopup(true);
    },
    // 注销渠道账户
    onLogout() {
      this.changeLogoutPopup(true);
    },
    changeLogoutPopup(val) {
      this.logoutPopup = val;
    },
    // 官网
    onOfficial() {
      window.location.href = this.config.operation_btn.office_website.link;
    },
    onActivePage() {
      window.location.href = this.config.operation_btn.join_active.link;
    },
    confirmLogout() {
      LogoutAPI().then((response) => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLogoutPopup(false);
          this.changeLoginPopup(true);
          this.$emit("reInit");
        }
      });
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitUserInfo",
      "setInitActiveInfo",
    ]),
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue